<template>
  <b-modal
    :title="`Crear actividad para expediente ${file.numero}`"
    v-model="showModal"
    hide-footer
    centered
    no-close-on-backdrop
    no-close-on-esc
    size="lg"
  >
    <div>
      <ActivityForm
        :selected-activity="{}"
        :column="createdColumn"
        :kanban-id="currentUserId"
        :reference-id="file.febosId"
        :reference-type="'EXP'"
        :reference-number="selectedFile.febosId"
        :edit-mode="false"
        :on-updated="() => this.editMode = false"
        :fromProcessedFile="true"
      />
    </div>
  </b-modal>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import ActivityForm from '@/febos/global/kanban/components/ActivityForm';
import { columns } from '@/febos/global/kanban/store/getters';

export default {
  name: 'KanbanTaskFile',
  components: { ActivityForm },
  data() {
    return {
      createdColumn: {},
      notValid: false
    };
  },
  props: {
    file: {
      type: [Object],
      required: true,
      default: () => {}
    }
  },
  watch: {
    comment() {
      this.notValid = false;
    },
    file() {
      this.notValid = false;
      this.comment = '';
    },
    columns(newVal) {
      this.createdColumn = newVal.find((column) => column.value.includes('creada'));
    }
  },
  computed: {
    ...mapGetters('Modals', [
      'modalName'
    ]),
    ...mapGetters('Dnts', [
      'selectedFile'
    ]),
    ...mapGetters('Usuario', [
      'currentUserId'
    ]),
    ...mapGetters('kanban', {
      columns: columns.name
    }),
    showModal: {
      get() {
        return this.modalName === 'kanbanTask';
      },
      set() {
        this.closeModal();
      }
    }
  },
  methods: {
    ...mapActions('Dnts', [
      'processDntFileED'
    ]),
    ...mapActions('Modals', [
      'closeModal'
    ])
  },
  mounted() {
    this.createdColumn = this.columns.find((column) => column.value.includes('creada'));
  }
};
</script>
<style scoped>
.chip-custom {
  font-size: 12px;
  margin-top: 10px;
  color: #ffb300;
  background: #fff5df;
  border-radius: 10px;
  padding: 4px 8px;
}
.wrap-commentary {
  width: 90%;
  margin: 20px auto;
}
</style>
